import { render, staticRenderFns } from "./BattleBrackets.vue?vue&type=template&id=3a599976&scoped=true"
import script from "./BattleBrackets.vue?vue&type=script&lang=js"
export * from "./BattleBrackets.vue?vue&type=script&lang=js"
import style0 from "./BattleBrackets.vue?vue&type=style&index=0&id=3a599976&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a599976",
  null
  
)

export default component.exports